import { MenuItem, Select } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import { Paid, PersonAddAlt } from "@mui/icons-material";
import React, {
  ChangeEvent,
  ChangeEventHandler,
  useEffect,
  useState,
  useRef,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getSalesItems } from "../../../../redux/actions/sales/sales";
import {
  resetTickets,
  setOrderType,
} from "../../../../redux/actions/tickets/tickets";
import LoadingComponent from "../../../loadingComponent/LoadingComponent";
import ItemCard from "../ItemCard/ItemCard";
import { cus_data } from "../registerCustomer/data";
import RegisterCustomer from "../registerCustomer/RegisterCustomer";
import SuccessModel from "../SuccessModel/SuccessModel";

//

//scss
import styles from "./Checkout.module.scss";

const Checkout = () => {
  const { ticketItems, total, orderType, discountType, discountAmount } =
    useSelector((state: any) => state.ticketReducer);

  const [totalPayable, settotalPayable] = useState<any>(total);
  const [totalPaid, settotalPaid] = useState<number>(0);
  const [inputValue, setinputValue] = useState<any>(totalPayable);
  const [roundOff, setRoundOff] = useState<number[]>([
    100, 200, 300, 400, 500, 1000, 5000, 10000,
  ]);
  const [roundOffUK, setRoundOffUK] = useState<number[]>([
    1, 2, 3, 4, 5, 10, 20, 50, 100,
  ]);
  const [paymentType, setpaymentType] = useState("cash");
  const [creditCustomerID, setcreditCustomerID] = useState<any>(-1);
  const [creditCustomerList, setcreditCustomerList] = useState(cus_data);
  const [creditedCustomer, setcreditedCustomer] = useState<any>();
  //console.log(inputValue);
  const [toggleRegister, settoggleRegister] = useState<boolean>(false);

  const inputRef = useRef<HTMLInputElement>(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const { itemList, loading, loaded } = useSelector(
    (state: any) => state.getSalesItemReducer
  );

  //const { user } = useSelector((state: any) => state.authentication);
  //console.log(user);

  // console.log("ticketReducer");
  // console.log(ticketItems);
  // console.log("total");
  // console.log(parseInt(total));
  // settotalPayable(parseInt(total));
  // console.log("orderType :", orderType);
  // console.log("inputValue :", inputValue);
  // console.log("totalPayable :", totalPayable);
  // console.log("totalPaid :", totalPaid);

  const totalSum = () => {
    var sum = 0;

    ticketItems.forEach(function (item: any) {
      sum += item.ItemPrice * item.ItemQuantity;
    });

    //settotalPayable(sum);
    return sum.toFixed(2);
  };

  useEffect(() => {
    dispatch(getSalesItems());
  }, [dispatch]);

  const closeSales = () => {
    //localStorage.removeItem("tickets");
    localStorage.setItem("tickets", JSON.stringify([]));
    localStorage.removeItem("total");
    dispatch(resetTickets());

    history.push("/sales");
  };

  const handlePay = (e: any) => {
    e.preventDefault();
    //console.log(e.target);
    console.log("value");
    console.log(inputValue);
    if (inputValue === totalPayable) {
      console.log("equal");
      settotalPaid(inputValue);

      // closeSales();
    } else {
      console.log("not equal");
      settotalPaid((prevState: number) => prevState + parseInt(inputValue));
    }
    //settotalPaid((prevState: number) => prevState + parseInt(inputValue));
  };

  const handleCreditPay = () => {
    const customerID = parseInt(creditCustomerID);
    // console.log(customerID);

    const cc = creditCustomerList.find(
      (item: any) => item.customer_code === customerID
    );
    //console.log(cc);
    setcreditedCustomer(cc);
    setcreditCustomerList((previousList: any) =>
      previousList.map((singleCustomer: any) =>
        singleCustomer.customer_code === customerID
          ? {
              ...singleCustomer,
              total_payable: totalPayable - totalPaid,
            }
          : singleCustomer
      )
    );

    settotalPaid(totalPayable);
    //console.table(creditCustomerList);

    // setcreditCustomerList((prevState: any) =>
    //   prevState.map((item: any) =>
    //     item.customer_code === customerID
    //       ? console.log(item.customer_name)
    //       : console.log("not found")
    //   )
    // );
  };

  const handleToggleRegister = () => {
    settoggleRegister(true);
  };
  // if (loading) {
  //   return <LoadingComponent />;
  // }
  useEffect(() => {
    settotalPayable(
      orderType === "pickup" ? total : ((total * 110) / 100).toFixed(2)
    );
    //setinputValue(totalPayable);
    if (orderType === "delivery") {
      //  setDefaultSelected(true);
      setinputValue(((total * 110) / 100).toFixed(2));
    }
    if (orderType === "pickup") {
      //  setDefaultSelected(true);
      setinputValue(total);
    }
  }, [orderType, total]);

  return (
    <div className={styles.checkout_container}>
      {totalPaid >= totalPayable && (
        <SuccessModel
          onClick={closeSales}
          balanceAmount={(totalPaid - totalPayable + discountAmount).toFixed(2)}
          paymentType={paymentType}
          customerName={
            creditedCustomer ? creditedCustomer.customer_name : "No name"
          }
        />
      )}
      <div className={styles.itemlist_container}>
        <div className={styles.top_bar}>
          {/* <span> Billing Items:</span> */}
          <Link to={"/sales"}>
            <ArrowBack />
          </Link>
          {/* <span>Add</span> */}
          {/* <select
            name=""
            id=""
            onChange={(e) => dispatch(setOrderType(e.target.value))}
          >
          
            <option className={styles.option} value="pickup">
              Pick up
            </option>
            
            <option value="delivery">Delivery</option>
          </select> */}
          <PersonAddAlt
            style={{ cursor: "pointer" }}
            onClick={handleToggleRegister}
          />
        </div>
        <div className={styles.item_list}>
          <table>
            <tr>
              <th>Item</th>
              <th>Unit price</th>
              <th>Quantity</th>
              <th>Total</th>
            </tr>

            {ticketItems &&
              ticketItems.map((item: any) => (
                <tr>
                  <td>{item.ItemName}</td>
                  <td>{item.ItemPrice.toFixed(2)}</td>
                  <td>{item.ItemQuantity}</td>
                  <td>{(item.ItemPrice * item.ItemQuantity).toFixed(2)}</td>
                </tr>
              ))}
          </table>
        </div>

        {ticketItems.length > 0 && (
          <>
            <div className={styles.ticket_total}>
              {/* <span>Rs.10000</span> */}
              <div className={styles.sub_total}>
                <span>Sub Total :</span>
                <span>Rs. {totalSum()}</span>
              </div>
              {discountType !== "" ? (
                <div className={styles.discount}>
                  <span>Discount :</span>
                  {discountType === "Amount" ? (
                    <span>{discountAmount.toFixed(2)}</span>
                  ) : (
                    <span>
                      {(Number(totalSum()) * discountAmount).toFixed(2)}
                    </span>
                  )}
                  {/* <span>{discountAmount}</span> */}
                </div>
              ) : (
                <div className={styles.discount}>
                  <span>Discount :</span>
                  <span>-</span>
                </div>
              )}

              <div className={styles.net_total}>
                {discountType === "" ? (
                  <>
                    <span>Net Total :</span>
                    <span>{total}</span>
                  </>
                ) : (
                  <>
                    <span>Net Total :</span>
                    {discountType === "Amount" ? (
                      <span>
                        {(Number(total) - discountAmount.toFixed(2)).toFixed(2)}
                      </span>
                    ) : (
                      <span>
                        {(
                          Number(total) -
                          Number(total) * discountAmount
                        ).toFixed(2)}
                      </span>
                    )}
                    {/* <span>{parseInt(totalSum()) - discountAmount}</span> */}
                  </>
                )}
              </div>
            </div>
          </>
        )}
      </div>
      <div className={styles.billing_container}>
        <div className={styles.top_bar_right}>
          <select
            name=""
            id=""
            onChange={(e: any) => setpaymentType(e.target.value)}
          >
            <option value="cash">Cash</option>
            <option value="credit">Credit</option>
          </select>
        </div>

        {/* <span>hello</span> */}

        <div className={styles.billing_header}>
          {totalPaid > totalPayable ? (
            <span>{(totalPaid - totalPayable).toFixed(2)}</span>
          ) : (
            <span>
              {(totalPayable - totalPaid - discountAmount).toFixed(2)}
            </span>
          )}

          {totalPaid > totalPayable ? (
            <p>Change amount</p>
          ) : (
            <p>Total amount due</p>
          )}
        </div>
        <div className={styles.billing_body}>
          {paymentType === "cash" ? (
            <div className={styles.input_container}>
              {/* <Paid /> */}
              <span>Cash recieved : </span>

              <input
                type="text"
                // defaultValue={defaultSelected ? inputValue : totalPayable}
                value={inputValue}
                // value={defaultSelected && inputValue}
                name="cashInput"
                ref={inputRef}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  // setDefaultSelected(false);
                  setinputValue(e.target.value);
                  console.log(e.target.value);
                }}
              />
              <button
                onClick={(e) => handlePay(e)}
                disabled={totalPaid >= totalPayable ? true : false}
              >
                Pay
              </button>
            </div>
          ) : (
            <div className={styles.input_container}>
              <select
                name=""
                id=""
                onChange={(e) => {
                  // console.log(e.target.value);
                  setcreditCustomerID(e.target.value);
                }}
              >
                <option value="">Select customer</option>
                {creditCustomerList &&
                  creditCustomerList.map((item: any) => (
                    <option value={item.customer_code}>
                      {item.customer_name}
                    </option>
                  ))}
              </select>
              <button onClick={handleCreditPay}>Pay Credit</button>
            </div>
          )}
        </div>
        <div className={styles.round_off_btn}>
          {totalPayable - totalPaid > 0 &&
            roundOffUK.map(
              (item: number) =>
                item > totalPayable - totalPaid && (
                  <button
                    onClick={() => {
                      setinputValue(item);
                      settotalPaid(item);
                    }}
                  >
                    {item.toFixed(2)}
                  </button>
                )
            )}
        </div>
        {/* <div className={styles.billing_footer}>
          <button
            onClick={closeSales}
            disabled={totalPayable > totalPaid ? true : false}
          >
            Start new sale
          </button>
        </div> */}
      </div>
      {toggleRegister && (
        <RegisterCustomer
          onClick={() => settoggleRegister(false)}
          customerList={creditCustomerList}
        />
      )}
    </div>
  );
};

export default Checkout;
